export default __webpack_public_path__ + "static/ai_main_banner-b9caf999111903cecefb5eb53ff0dab5.webp";